
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hotel]",
      function () {
        return require("private-next-pages/[hotel]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hotel]"])
      });
    }
  